// Lista de ubicaciones (sites)

import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import SiteForm from './SiteForm';
import { apiFetch, apiFetchJson } from '../fetchWrapper';
import { useUser } from '../UserContext';

export default function SiteList({ clientId, disableActions = false }) {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingSite, setEditingSite] = useState(null);
  const { user, hasRole } = useUser();


  const enableActions = hasRole("ADMIN", "HR_ADMIN");

  useEffect(() => {
    setLoading(true);

    if (!clientId) {
      setLoading(false);
      return;
    }

    const url = `/api/clients/${clientId}/sites`;

    apiFetchJson(url)
      .then(setSites)
      .catch((err) => {
        console.error('Failed to load sites', err);
        setError(err.message || 'Failed to load');
      })
      .finally(() => setLoading(false));
  }, [clientId]);

  const handleEdit = async (site) => {
    setEditingSite(site);
    setShowForm(true);
  }

  const handleAdd = async (id) => {
    setEditingSite(null);
    setShowForm(true);
  }

  const handleDelete = async (id) => {
    const confirmed = window.confirm('¿Desea eliminar esta ubicación/sitio?');
    if (!confirmed) return;

    try {
      await apiFetch(`/api/sites/${id}`, { method: 'DELETE' });
      alert('Sitio eliminado');
      setSites(prev => prev.filter(site => site.id !== id));
    } catch (err) {
      console.error(err);
      alert('Error al eliminar el sitio');
    }
  }

  const handleSave = (savedSite) => {
    setSites(prev => {
      const exists = prev.some(s => s.id === savedSite.id);
      if (exists) {
        return prev.map(s => s.id === savedSite.id ? savedSite : s);
      }
      return [...prev, savedSite];
    });
    setShowForm(false);
  };

  if (loading) return <div>Loading sites…</div>;
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;
  return (
    <>
      {showForm && (
        <SiteForm
          site={editingSite}
          clientId={clientId}
          onCancel={() => setShowForm(false)}
          onSave={handleSave}
        />
      )}

      {enableActions && (
        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2}>
          {clientId && (
            <Button
              sx={{
                backgroundColor: "#3f74b1",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#364f6b"
                },
                marginTop: 1
              }}
              variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAdd}>
              Agregar Ubicación
            </Button>
          )}
        </Box>
      )}

      {sites.length > 0 && (
        <TableContainer component={Paper}>
          <Box sx={{ px: 2, py: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Ubicaciones:
            </Typography>
          </Box>
          <Table>
            <TableHead
              sx={{
                backgroundColor: '#f5f5f5',
                textTransform: 'uppercase',
              }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Nombre Ubicación</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Dirección</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Ciudad</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Estado</TableCell>
                {enableActions && (
                  <TableCell sx={{ fontWeight: "bold" }}>Acciones</TableCell>
                )}

              </TableRow>
            </TableHead>

            <TableBody>
              {sites.map((row) => (
                <TableRow key={row.id}
                  hover
                  sx={{
                    "&:hover .MuiTableCell-root": {
                      backgroundColor: "action.hover",
                    },
                  }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.address?.street || '-'}</TableCell>
                  <TableCell>{row.address?.city || '-'}</TableCell>
                  <TableCell>{row.address?.state || '-'}</TableCell>
                  {enableActions &&
                    <TableCell>
                      <Tooltip title="Editar"
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px'
                            }
                          }
                        }}
                      >
                        <IconButton
                          color="primary"
                          onClick={() => handleEdit(row)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Borrar"
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '12px'
                            }
                          }
                        }}
                      >
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(row.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>

                    </TableCell>
                  }
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
